export default "__VITE_ASSET__x2LIEV8a__"